export default __webpack_public_path__ + "static/media/graphql.03720570.png";